import React, { FC, memo, useMemo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { MarginProps } from '../../../utils/styling/StylingHelper'
import SmallTeaserHeadlineFont from '../../../Theme/Fonts/SmallTeaserHeadline'
import PlayerImage from '../../../BaseComponents/Image/Player'
import TeamImage from '../../../BaseComponents/Image/Team'
import BasicText from '../../../Theme/Fonts/BasicText'
import { Assist, Goal } from '../HelperClass/Icons'

export type TickerPlayerProps = {
    /**
     * players name, in format of FirstName LastName
     */
    playerName: string
    /**
     * players Image Url,to be shown in left corner
     */
    playerImageUrl: string
    /**
     * team logo Url,to be shown below playername next to team name
     */
    teamLogoUrl: string
    /**
     * team name ,to be shown next to team logo
     */
    teamName: string
    /**
     * optional player status icon displayed in upper right corner
     */
    playerStatusIcon?: 'IN' | 'OUT' | 'GOAL' | 'ASSIST'
    /**
     * action called when pressed on the whole row
     * @TJS-type: function
     */
    onPressRow: () => void
} & TestID &
    Pick<MarginProps, 'marginY' | 'marginRight'>

const TickerPlayer: FC<TickerPlayerProps> = ({
    playerImageUrl,
    playerName,
    teamLogoUrl,
    teamName,
    playerStatusIcon,
    onPressRow,
    testID,
    marginY,
    marginRight,
}) => {
    const rightIcon = useMemo(() => {
        let fontello = null
        if (playerStatusIcon === 'IN') {
            fontello = <FontelloIcon name="arrow-top" fontSize={12} color="GREEN" />
        } else if (playerStatusIcon === 'OUT') {
            fontello = <FontelloIcon name="arrow-bottom" fontSize={12} color="RED" />
        } else if (playerStatusIcon === 'GOAL') {
            return <Goal fontSize="FS14" />
        } else if (playerStatusIcon === 'ASSIST') {
            return <Assist fontSize="FS14" />
        }
        return fontello ? (
            <Grid noExpand marginLeft={20} centerVertical>
                {fontello}
            </Grid>
        ) : null
    }, [playerStatusIcon])

    return (
        <Grid
            noExpand
            backgroundColor="pearl"
            height={38}
            marginY={marginY}
            marginRight={marginRight}
            testID={testID}
        >
            <Touchable onPress={onPressRow} expand>
                <Grid horizontal centerVertical>
                    <PlayerImage imageUrl={playerImageUrl} size="S" width={30} />
                    <Grid minWidth={0} marginTop={-2} marginLeft={3}>
                        <BasicText fontSize="FS16" lineHeight="LH22" numberOfLines={1} bold>
                            {playerName}
                        </BasicText>
                        <Grid horizontal centerVertical>
                            <TeamImage imageUrl={teamLogoUrl} width={12} size="S" />
                            <Grid minWidth={0} marginLeft={2}>
                                <SmallTeaserHeadlineFont numberOfLines={1} color="onyx-4">
                                    {teamName}
                                </SmallTeaserHeadlineFont>
                            </Grid>
                        </Grid>
                    </Grid>
                    {rightIcon}
                </Grid>
            </Touchable>
        </Grid>
    )
}
export default memo(TickerPlayer)
